import React, { Fragment } from 'react';
import DivButton from 'components/v2/div-button/div-button';
import PropTypes from 'prop-types';
import { Collapse } from 'grab-ui';
import I18n from 'i18n-js';
import css from './company-selector.less';

const { Panel } = Collapse;

const renderExpandIconMobile = () => (
  <img src={require('public/icons/collapsed.svg')} alt="" />
);
const CompanySelectorMobile = props => {
  const {
    profiles,
    currentProfileName,
    currentGroupName,
    onSelectProfile,
  } = props;

  return (
    <Collapse
      expandIconPosition="right"
      expandIcon={renderExpandIconMobile}
      accordion
      className={css.companySelectorMobile}
    >
      <Panel
        header={
          <div>
            <p>{currentProfileName}</p>
            <p>{currentGroupName}</p>
          </div>
        }
      >
        {profiles.map(p => (
          <Fragment key={p.id}>
            <div className={css.companyHeader}>
              {I18n.t(p.name, { defaultValue: p.name })}
            </div>
            {p.groups.map(g => (
              <DivButton onClick={() => onSelectProfile(p.id, g.id)} key={g.id}>
                {I18n.t(g.name, { defaultValue: g.name })}
              </DivButton>
            ))}
          </Fragment>
        ))}
      </Panel>
    </Collapse>
  );
};

CompanySelectorMobile.propTypes = {
  profiles: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  currentProfileName: PropTypes.string.isRequired,
  currentGroupName: PropTypes.string.isRequired,
  onSelectProfile: PropTypes.func.isRequired,
};
export default CompanySelectorMobile;
